import React, { useEffect } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import {
  Button,
  CardActionArea,
  CardActions,
  Grid,
  Dialog,
  DialogContent,
  TextField,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from "react-beautiful-dnd";
import {
  Image,
  Picture,
  PictureValidationSchema,
} from "../../models/features/Product/Product";
import { PictureInitialValues } from "./../../models/features/Product/Product";
import {
  useAddPartImageMutation,
  useDeletePartImageMutation,
} from "../../redux/reducer/features/Part/partSlice";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PageLoader from "../app/PageLoader";

interface ManageImageProps {
  partId: string;
  images: Image[];
  partDetail?: any;
  setPartDetail?: any;
}
const ManagePartImage: React.FunctionComponent<ManageImageProps> = ({
  partId,
  images,
  partDetail,
  setPartDetail,
}) => {
  const [partImage, setPartImage] = React.useState<Image[]>(images);
  const [deleteMutation, deleteMutationResult] = useDeletePartImageMutation();
  const [imageFile, setImageFile] = React.useState<File>();
  const [partImageMutation, partImageMutationResult] =
    useAddPartImageMutation();
  const [isOpen, setOpen] = React.useState(false);
  const [selectedImageId, setSelectedImageId] = React.useState("");
  const [URL, setURL] = React.useState("");
  const [Formopen, setFormOpen] = React.useState(false);
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);

  function onDragEnd(result: DropResult) {
    console.log(result);
    if (result.destination && result.source) {
      if (result.destination?.index !== result.source.index) {
        setPartImage(
          partImage.map((item) => {
            if (item.sequence === result.source.index) {
              return { ...item, sequence: result.destination?.index ?? 0 };
            } else if (
              result.destination &&
              item.sequence > result.destination?.index
            ) {
              return { ...item, sequence: item.sequence + 1 };
            } else {
              return item;
            }
          })
        );
      }
    }
  }
  const handleClickOpen = () => {
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
  };
  const handleLightBoxOpen = () => {
    setOpen(true);
  };
  const handleLightBoxClose = () => {
    setOpen(false);
    setDeleteConfirm(false);
  };

  const handleUploadClick = (e: any) => {
    var file = e.target.files[0];
    setImageFile(file);
  };

  const handleDelete = (Id: any) => {
    setDeleteConfirm(false);
    setPartImage(partImage.filter((img) => img.id !== Id));
    deleteMutation({ data: { id: Id } });
  };

  const handleOnSubmit = (values: Picture) => {
    if (imageFile) {
      const formData = new FormData();
      formData.append("formFile", imageFile);
      formData.append("productId", partId);
      formData.append("title", values.title);
      formData.append("description", values.description ?? "");
      partImageMutation({ data: formData });
    } else {
      console.log("File not Selected");
    }
  };

  useEffect(() => {
    if (partImageMutationResult.isSuccess) {
      setPartImage([
        ...partImage,
        {
          sequence: 15,
          title: partImageMutationResult.data.entity?.title ?? "",
          url: partImageMutationResult.data.entity?.url ?? "",
          absoluteUrl: partImageMutationResult.data.entity?.absoluteUrl ?? "",
          id: partImageMutationResult.data.entity?.id ?? "",
        },
      ]);
      setFormOpen(false);
      setPartDetail({
        ...partDetail,
        images: [
          ...partDetail?.images,
          {
            sequence: 15,
            title: partImageMutationResult.data.entity?.title ?? "",
            url: partImageMutationResult.data.entity?.url ?? "",
            absoluteUrl: partImageMutationResult.data.entity?.absoluteUrl ?? "",
            id: partImageMutationResult.data.entity?.id ?? "",
          },
        ],
      });
    }
  }, [partImageMutationResult]);
  return (
    <>
      <PageLoader isLoading={partImageMutationResult.isLoading} />
      <DragDropContext onDragEnd={onDragEnd}>
        <Grid container spacing={3} p={2}>
          {partImage
            .slice()
            .sort((a, b) => a.sequence - b.sequence)
            .map((item, index) => (
              <Droppable key={index} droppableId={index.toString()}>
                {(provided) => (
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    className="list-container"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    <Draggable
                      key={item.url}
                      draggableId={index.toString()}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          className="item-container"
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          <Card sx={{ maxWidth: 345 }}>
                            <CardActionArea>
                              <CardMedia
                                component="img"
                                height="200"
                                image={item?.absoluteUrl ?? ""}
                                alt="green iguana"
                                onClick={() => {
                                  handleLightBoxOpen();
                                  setURL(item?.absoluteUrl ?? "");
                                }}
                              />
                              <CardContent>
                                <Typography
                                  gutterBottom
                                  variant="h5"
                                  component="div"
                                >
                                  {item.title}
                                </Typography>
                              </CardContent>
                            </CardActionArea>
                            <CardActions>
                              <DeleteForeverIcon
                                sx={{ color: "red", cursor: "pointer" }}
                                onClick={() => {
                                  setDeleteConfirm(true);
                                  setSelectedImageId(item.id ?? "");
                                  //handleDelete(item.id);
                                }}
                              />
                            </CardActions>
                          </Card>
                        </div>
                      )}
                    </Draggable>

                    {provided.placeholder}
                  </Grid>
                )}
              </Droppable>
            ))}
          <Grid item xs={12} sm={3}>
            <Card sx={{ maxWidth: 345 }} onClick={handleClickOpen}>
              <CardActionArea
                sx={{
                  textAlign: "center",
                  paddingTop: 14,
                  paddingBottom: 13.5,
                  color: "#8392ab",
                }}
              >
                <CardContent>
                  <AddIcon />
                  <Typography gutterBottom variant="h5" component="div">
                    New Image
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </DragDropContext>
      <Dialog
        open={Formopen}
        onBackdropClick={() => {
          handleFormClose();
        }}
      >
        <DialogTitle alignSelf={"center"}>Add Image</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={PictureInitialValues}
            validationSchema={PictureValidationSchema}
            onSubmit={(values) => {
              handleOnSubmit(values);
            }}
            enableReinitialize={true}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
            }) => (
              <>
                <Form>
                  <Grid
                    container
                    spacing={3}
                    justifyContent="space-between"
                    display="flex"
                    p={5}
                  >
                    <Grid item xs={12}>
                      <TextField
                        id="title"
                        name="title"
                        label="Title"
                        fullWidth
                        autoComplete="family-name"
                        variant="standard"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.title}
                      />
                      <ErrorMessage
                        className="error-msg"
                        component={"div"}
                        name="title"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="description"
                        name="description"
                        label="Description"
                        fullWidth
                        autoComplete="family-name"
                        variant="standard"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.description}
                      />
                      <ErrorMessage
                        className="error-msg"
                        component={"div"}
                        name="description"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        type="file"
                        id="imageFile"
                        name="imageFile"
                        label="Image"
                        fullWidth
                        autoComplete="family-name"
                        variant="standard"
                        onChange={handleUploadClick}
                        onBlur={handleBlur}
                      />
                      <ErrorMessage
                        className="error-msg"
                        component={"div"}
                        name="File"
                      />
                    </Grid>

                    <Grid item xs={12} mt={3}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-end"
                      >
                        <Grid item>
                          <Button
                            color="error"
                            variant="contained"
                            onClick={() => {
                              handleFormClose();
                            }}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            type="submit"
                            onClick={() => {
                              console.log(errors);
                              console.log(values);
                            }}
                          >
                            Save
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              </>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
      {isOpen && (
        <Lightbox mainSrc={URL} onCloseRequest={handleLightBoxClose} />
      )}
      <Dialog open={deleteConfirm} onClose={handleLightBoxClose} fullWidth>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Confirm to delete
        </DialogTitle>
        <DialogContent>Are you sure to delete this Image?</DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            onClick={() => {
              if (selectedImageId) handleDelete(selectedImageId);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManagePartImage;
